import React, {useRef, useState, useEffect} from 'react';
import * as S from './UpdateMobile.styles';
import OTPBlock from '../../../../../../../../onboarding/src/stories/components/UI/OTP/otp';
import ButtonLoader from '../../../../../../../../onboarding/src/stories/components/UI/Loader/Loader';
import {validations} from '../../../../../../utils/validations';
import IconSelector from '@ibibo/icon-selector';
import {sendEvarData} from '@ibibo/analytics';

const UpdateMobilePop = ({userNumber, resendOtp, clickActive, closePop, submitUpdateOtp, sendMobileOtp, numberExist, errorUpdateOtp, btnLoad}) => {
    const otpRef = useRef(null);

    const [showError, setShowError] = useState('');
    const [mobileNo, setMobileNo] = useState();
    const [showMobile, setShowMobile] = useState(numberExist);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [showEdit, setShowEdit] = useState(true);
    const [errors, setError] = useState({});

    const submitUserOtp = (event: React.FormEvent) => {
        event.preventDefault();
        const otpStr = otpRef.current.value;
        submitUpdateOtp(otpStr);
        sendEvarData({
            prop54: "myPatner|profile|updatePhone|submitOtp"
        }, true)
    }

    useEffect(() => {
        setShowEdit(true);
    },[])

    useEffect(() => {
        if(errorUpdateOtp !== ''){
            setShowError(errorUpdateOtp);
            setButtonDisabled(true);
        }else{
            setShowError('');
            setButtonDisabled(false);
        }
    }, [errorUpdateOtp]);

    useEffect(() => {
        if(numberExist){
            setShowMobile(numberExist);
        }else{
            setShowEdit(false);
        }
    },[numberExist]);
    
    const fieldValidators = {
        'mobile': {'field': 'mobile', 'fieldName': 'Mobile', 'validators': ['required', 'validMobileNumber']},
    };
    
    const validateFields = (data) => {
        let errorObj = {};
        setError({});
        Object.keys(data).map(key => {
            if (fieldValidators[key]) {
            const validators = fieldValidators[key].validators;
            for (let i = 0; i < validators.length; i++) {
                const validateFunction = validations[validators[i]];
                const resp = validateFunction({
                value: data[key],
                fieldName: fieldValidators[key].fieldName,
                });
                if (resp && !errorObj[key]) {
                errorObj[key] = resp;
                }
            }
            }
        });
        setError(errorObj);
        if (Object.keys(errorObj).length) {
            return true;
        }
        return false;
    }

    const onChangeHandler = (field, value) => {
        setMobileNo(value);
        setButtonDisabled(false);
    }

    const sendOtp = (event: React.FormEvent) => {
        event.preventDefault();
        const data = {mobile: mobileNo};
        const hasError = validateFields(data);
        if(!hasError){
            sendMobileOtp(data);
            // setShowEdit(false);
        }
        sendEvarData({
            prop54: "myPatner|profile|updatePhone|sendOtp"
        }, true)
    }

    return(
        <S.MobileVerifyPopWrap>
            <S.MobileVerifyPopContentWrap>
                <S.MobileVerifyPopHeadWrap>
                    <S.PopBackBtn onClick={closePop}>Close</S.PopBackBtn>
                </S.MobileVerifyPopHeadWrap>
                <S.MobileVerifyBodyWrap>
                    {!showEdit && (
                        <S.VerifyForm onSubmit={submitUserOtp}>
                            <S.MobileVerifyBodyHeadWrap>
                                <S.MobileVerifyMainText>Update Mobile Number</S.MobileVerifyMainText>
                                <S.MobileVerifyInfoWrap>
                                    <S.MobileVerifyInfoText>OTP  has been sent to your mobile number +91{mobileNo}</S.MobileVerifyInfoText>
                                </S.MobileVerifyInfoWrap>
                                <S.OptBlockWrap>
                                    <OTPBlock 
                                        ref={otpRef}
                                        label=""
                                        subLabel=""
                                        otpLength={6}
                                        type="aadhar_number"
                                        resendOTP = {() => resendOtp()}
                                        autoFocus={true}
                                        resendVisible={clickActive}
                                    />
                                    {(showError && <S.ErrorText>{showError}</S.ErrorText>) || null}
                                </S.OptBlockWrap>
                                <S.OtpFooterBtnWrap>
                                <S.CancelBtn onClick={closePop}>Cancel</S.CancelBtn>
                                        <S.SubmitBtn type="submit" disabled={buttonDisabled}>{btnLoad ? <ButtonLoader loaderType="button"/> : 'Submit Otp'}</S.SubmitBtn>
                                </S.OtpFooterBtnWrap>
                            </S.MobileVerifyBodyHeadWrap>
                        </S.VerifyForm> )
                    || (
                        <S.VerifyForm onSubmit={sendOtp}>
                            <S.EmailVerifyBodyHeadWrap>
                                <S.EmailVerifyMainText>Enter New Mobile Number</S.EmailVerifyMainText>
                                <S.InputWrap>
                                    <IconSelector iconKey="india" />
                                    <S.LoginPrefix>+91</S.LoginPrefix>
                                    <S.CommonInput 
                                        type="text"
                                        placeholder="New Mobile Number"
                                        name="mobile"
                                        value={mobileNo}
                                        onChange={event => onChangeHandler('mobile', event.target.value)}
                                        hasError={errors['mobile'] ? true : false}
                                    />
                                </S.InputWrap>
                                {(errors && <S.ErrorText>{errors['mobile']}</S.ErrorText> ) || null}
                                {(showError && <S.ErrorText>{showError}</S.ErrorText>) || null}
                                <S.OtpFooterBtnWrap>
                                    <S.CancelBtn onClick={closePop}>Cancel</S.CancelBtn>
                                    <S.SubmitBtn type="submit" disabled={buttonDisabled}>{btnLoad ? <ButtonLoader loaderType="button"/> : 'Send otp'}</S.SubmitBtn>
                                </S.OtpFooterBtnWrap>
                            </S.EmailVerifyBodyHeadWrap>
                        </S.VerifyForm>
                    )
                    }
                </S.MobileVerifyBodyWrap>
            </S.MobileVerifyPopContentWrap>
        </S.MobileVerifyPopWrap>
    )
}

export default UpdateMobilePop;